import slick from '../vendors/slider.min';

class MarsSlideshow {
  constructor() {
    this.dots = $('.slick-dots li');
    this.initSliders();
  }

  initSliders() {
    $(
      '.homepage_slider__stories, .hubSlider__nav, .storySlider__nav, .pageHeaderSlider, .lcrsSection__slider, .quotesVideo__quotes, .testimonialsSlider__slides, .videoContentSlider__slider, .featuredImage__slider'
    ).on('init', (event, slick) => {
      $('.slick-dots li.slick-active')
        .append(`<svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
        <circle class="circle-chart__background" stroke="#DEDEDE" stroke-width="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
          <circle class="circle-chart__circle" stroke="#003DA5" stroke-width="2" stroke-dasharray="100,100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
      </svg>`);
    });

    // $(".homepage_slider__stories, .hubSlider__nav, .storySlider__nav, .pageHeaderSlider, .lcrsSection__slider, .quotesVideo__quotes").on('beforeChange', (event, slick) => {
    //   this.onBeforeChange();
    // });

    $(
      '.homepage_slider__stories, .hubSlider__nav, .storySlider__nav, .pageHeaderSlider, .lcrsSection__slider, .quotesVideo__quotes, .testimonialsSlider__slides, .videoContentSlider__slider, .featuredImage__slider'
    ).on('afterChange', (event, slick) => {
      this.onAfterChange();
    });

    $('.homepage_slider__stories').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.lcrsSection__slider, .quotesVideo__quotes').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.featuredImage__slider').slick({
      dots: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.videoContentSlider__slider').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.pageHeaderSlider').slick({
      dots: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      mobileFirst: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.testimonialsSlider__slides').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
    });

    $('.hubSlider__slider, .storySlider__slider').on(
      'init',
      (event, slick) => {}
    );

    $('.hubSlider__slider').on(
      'beforeChange',
      function (event, slick, currentSlide, nextSlide) {
        // var mySlideNumber = nextSlide;
        // $('.hubSlider__nav .slick-slide').removeClass('slick-active');
        // $('.hubSlider__nav .slick-slide').eq(mySlideNumber).addClass('slick-active');
      }
    );

    $('.hubSlider__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      arrows: false,
      fade: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      asNavFor: '.hubSlider__nav',
      accessibility: false,
    });
    $('.hubSlider__nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.hubSlider__slider',
      infinite: true,
      arrows: false,
      dots: true,
      useTransform: false,
      dotsClass: 'slick-dots',
      variableWidth: true,
      focusOnSelect: true,
      useCSS: true,
      accessibility: false,
    });

    $('.storySlider__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      arrows: false,
      fade: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      asNavFor: '.storySlider__nav',
      accessibility: false,
    });
    $('.storySlider__nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.storySlider__slider',
      infinite: true,
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots',
      useTransform: false,
      variableWidth: true,
      focusOnSelect: true,
      useCSS: true,
      accessibility: false,
    });

    // Remove active class from all thumbnail slides
    $(
      '.hubSlider__nav .slick-slide, .storySlider__nav .slick-slide'
    ).removeClass('slick-active');

    // Set active class to first thumbnail slides
    $('.hubSlider__nav .slick-slide, .storySlider__nav .slick-slide')
      .eq(0)
      .addClass('slick-active');
  }

  sliderEvents() {}

  onBeforeChange() {
    $('.circle-chart').remove();
    $('.slick-dots li.slick-active').next()
      .append(`<svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
  <circle class="circle-chart__background" stroke="#DEDEDE" stroke-width="2.5" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
  <circle class="circle-chart__circle" stroke="#003DA5" stroke-width="2.5" stroke-dasharray="100,100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
</svg>`);
  }

  onAfterChange() {
    $('.circle-chart').remove();
    $('.slick-dots li.slick-active')
      .append(`<svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
  <circle class="circle-chart__background" stroke="#DEDEDE" stroke-width="2.5" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
  <circle class="circle-chart__circle" stroke="#003DA5" stroke-width="2.5" stroke-dasharray="100,100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
</svg>`);
  }
}

export default MarsSlideshow;
